<script setup lang="ts">
import { numHelper } from '@/utils/numHelper.ts'
import { computed } from 'vue'

interface Props {
  amount?: number | string | null;
}

const props = defineProps<Props>();

const amount = computed(() => (props.amount ? numHelper(props.amount).format(0, ',', '.') : '--'));
const amountText = computed(() => (props.amount ? numHelper(props.amount).numberToVietnameseText() : '--'));
</script>

<template>
  <div class="money-amount">
      <span class="block font-bold whitespace-nowrap">{{amount}} <sup>đ</sup></span>
      <span class="block text-[11px] font-italic text-[#FF0000]">{{amountText}}</span>
  </div>
</template>

<style lang="scss">
.money-amount{
  display: flex;
  flex-direction: column;
}
</style>
